import { render, staticRenderFns } from "./formulaLog.vue?vue&type=template&id=566920dc&scoped=true"
import script from "./formulaLog.vue?vue&type=script&lang=js"
export * from "./formulaLog.vue?vue&type=script&lang=js"
import style0 from "./formulaLog.vue?vue&type=style&index=0&id=566920dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566920dc",
  null
  
)

export default component.exports